































































































































import DatePickerSingle from '../../core/components/DatePickerSingle.vue';
import Input from '../../core/components/Input.vue';
import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray,
    formatDate,
    parseFloatNumber,
    matchedIndexIdInArray,
    getUniqueId,
    getIdsFromList
} from '../../core/utils';
import { formattedDate } from '../../core/utils/table-formatters';
import { Destroyed } from '../../core/decorators';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import Button from '../../core/components/Button.vue';
import MultipleSelect from '../../core/components/MultipleSelect.vue';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import { InsuranceServices } from '../api/InsuranceServices';

@Component({
    components: {
        Input,
        Button,
        DatePickerSingle,
        // HourSelector,
        MultipleSelect
    }
})
export default class ModalReprocessVehiclesAndPeriods extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop() visible: boolean;
    @Prop({default: false}) isSowing: boolean;
    @Prop({default: -1}) harvestId: number;
    @Prop() vehicleID: number;
    @Prop({default: -1}) sowingId: number;
    @Prop({default: false}) reprocessPeriods: boolean;
    @Prop({default(){return []}}) vehicles: Array<object>;
    reprocessVehiclesTitle: string = 'Reprocesar Vehículos';
    reprocessPeriodsTitle: string = 'Reprocesar Períodos';
    reprocessPeriodsText: string = 'Seleccionar Períodos para reprocesar';
    reprocessVehiclesText: string = 'Seleccionar Vehículos para reprocesar';
    modalTitle: string = '';
    dateRangeSelected: any = [];
    errorMsg: string = '';
    hasToReprocessPeriods: boolean = false;
    loadingBtn: boolean = false;
    startDate: any = null;
    startHour: string = '';
    endDate: any = null;
    endHour: string = '';
    preselectedVehicles: Array<object> = [];

    selectVehicle(vehicle){
        if(vehicle){
            this.preselectedVehicles.push(vehicle);
        }
    }
    removeVehicle(vehicle){
       this.preselectedVehicles = this.preselectedVehicles.filter(item => item['id'] !== vehicle.id);
    }

    parseCalibrationType(calibrationType) {
        let calibrationTypeIndex = this.$_getInsuranceProperties['calibration_type_easy_desc'].findIndex(
            item => Number(item['id']) == calibrationType
        );

        if (calibrationTypeIndex !== -1) {
            return this.$_getInsuranceProperties['calibration_type_easy_desc'][calibrationTypeIndex]['value'];
        }
    }

    setErrorForm(text) {
        this.errorMsg = text;
    }


    showLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }
    showSuccessLoadingDialog(response, alternative_msg){
        this.$_successLoadingDialog({
            response: response,
            alternative_msg: alternative_msg
        });
        this.closeModal();
    }
    showCatchLoadingDialog(error, alternative_msg){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }

    updateStartDate(value) {
        this.startDate = value;
    }
    updateStartHour(value) {
        this.startHour = value;
    }
    updateEndDate(value) {
        this.endDate = value;
    }
    updateEndHour(value) {
        this.endHour = value;
    }

    pendingRequest(value){
        this.loadingBtn = value;
    }

    submit() {
        let data = this.getData;
        this.pendingRequest(true);
        if(this.reprocessPeriods){
            this.reprocessPeriodsAction(data);
        }else{
            this.reprocessVehiclesAction(data);
        }
    }

    reprocessPeriodsAction(data){
        if(this.isSowing){
          this.recalculateSowingPeriods(data);
        }else{
            this.recalculateHarvestPeriods(data);
        }
        
    }
    reprocessVehiclesAction(data){
        if(this.isSowing){
             this.recalculateSowingVehicles(data);
        }else{
            this.recalculateHarvestVehicles(data)
        }
       
    }

    showSuccessPeriods(res){ 
       this.showSuccessLoadingDialog(res, 'Los dias solicitados quedaron programados para recalcular');
    }
    showSuccessVehicles(res){ 
        this.showSuccessLoadingDialog(res, 'Los vehiculos solicitados quedaron programados para recalcular');
    }

    recalculateHarvestPeriods(data){
        InsuranceServices.harvestRecalculatePeriods(
            this.harvestId,
            data
        ).then((res) => {
            this.pendingRequest(false);
            this.updateHarvestReprocessData(res.harvest_reprocess_data)
            this.showSuccessPeriods(res)
        }).catch((err) => {
            this.pendingRequest(false);
            this.showCatchLoadingDialog(err, 'No se pudieron reprocesar los períodos');
        })
    }
    recalculateSowingPeriods(data){
        InsuranceServices.sowingRecalculatePeriods(
            this.sowingId,
            data
        ).then((res) => {
            this.pendingRequest(false);
            this.updateSowingReprocessData(res.sowing_reprocess_data)
           this.showSuccessPeriods(res)
        }).catch((err) => {
            this.pendingRequest(false);
            this.showCatchLoadingDialog(err, 'No se pudieron reprocesar los períodos');
        })
    }

    recalculateSowingVehicles(data){
        InsuranceServices.sowingRecalculateVehicles(
            this.sowingId,
            data
        ).then((res) => {
            this.pendingRequest(false);
            this.updateSowingReprocessData(res.sowing_reprocess_data)
           this.showSuccessVehicles(res);
        }).catch((err) => {
            this.pendingRequest(false);
            this.showCatchLoadingDialog(err, 'No se pudieron reprocesar los vehículos');
        })
    }

    recalculateHarvestVehicles(data){
        InsuranceServices.harvestRecalculateVehicles(
            this.harvestId,
            data
        ).then((res) => {
            this.pendingRequest(false);
            this.updateHarvestReprocessData(res.harvest_reprocess_data)
           this.showSuccessVehicles(res);
        }).catch((err) => {
            this.pendingRequest(false);
            this.showCatchLoadingDialog(err, 'No se pudieron reprocesar los vehículos');
        })
    }

    @Emit()
    updateSowingReprocessData(data){}

    @Emit()
    updateHarvestReprocessData(data){}


    updateFields() {
        this.updateStartHour('00:00');
        this.updateEndHour('23:59');
        if(this.reprocessPeriods){
            this.modalTitle = this.reprocessPeriodsTitle;
        }else{
            this.modalTitle = this.reprocessVehiclesTitle;
        }
        // console.log("vehiculos", this.vehicles);
    }

    get getData() {
        return {
            vehicles: getIdsFromList(this.preselectedVehicles),
            ...(this.reprocessPeriods ? { start_date: this.getFullTimestamp(this.startDate, this.startHour) } : {}),
            ...(this.reprocessPeriods ? { end_date: this.getFullTimestamp(this.endDate, this.endHour) } : {}),
            recalculate_periods: this.hasToReprocessPeriods
        };
    }

    getFullTimestamp(date, hour) {
        return date + 'T' + hour;
    }

    get formIsValid() {
        this.setErrorForm('');
        if (this.reprocessPeriods && this.startDate == null) {
            this.setErrorForm('No seleccionó Fecha de Inicio');
            return false;
        }

        if (this.reprocessPeriods && this.endDate == null) {
            this.setErrorForm('No seleccionó Fecha de Fin');
            return false;
        }

        if (this.preselectedVehicles.length == 0) {
            this.setErrorForm('No seleccionó ningún vehículo');
            return false;
        }

        return true;
    }

    @Emit()
    closeModal() {}

    @Emit()
    addNewManualFactor(item) {
        return item;
    }

    @Emit()
    updateManualFactor(item) {
        return item;
    }

    mounted() {
        this.updateFields();
    }
}
